import {BackendData} from "@app/_model/backend.data";
import {compareRoles, RoleType} from "@app/_model/role";
import {Account} from "@app/_model/account";

/**
 * Jogosultság
 *
 * @class Permission
 */
export class Permission extends BackendData {
  permission: RoleType;
  permitted: boolean;

  constructor(
    id: number,
    permission: RoleType | string,
    permitted: boolean,
    inserted: Date | undefined,
    insertedBy: Account | undefined,
    updated: Date | undefined,
    updatedBy: Account | undefined
  ) {
    super(id, inserted, insertedBy, updated, updatedBy);
    this.permission = Object.values(RoleType).includes(permission as RoleType) ? permission as RoleType : RoleType[permission as keyof typeof RoleType];
    this.permitted = permitted;
    this.log.trace('Permission:', this);
  }

  public static of(permission: Permission | any): Permission {
    return new Permission(permission.id, permission.permission, permission.permitted, permission.inserted, permission.insertedBy, permission.updated, permission.updatedBy);
  }

  public static isPermitted(roleNeed: RoleType, roleHave: RoleType | RoleType[]): boolean {
    if (Array.isArray(roleHave)) {
      let permitted = false;
      roleHave.forEach((role) => {
        if(this.isPermitted(roleNeed, role)) {
          permitted = true;
        }
      });
      return permitted;
    } else {
      return compareRoles(roleHave, roleNeed) >= 0;
    }
  }

  public isPermitted(roleNeed: RoleType) {
    return Permission.isPermitted(roleNeed, this.permission);
  }
}
